import type { CategoryId } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import type { State } from '../../types.tsx';

export const getArticleIdsForCategory = (state: State, categoryId: CategoryId, page = 1) =>
	state.entities.browse[categoryId]
		? state.entities.browse[categoryId].pages[`${page}`]
		: undefined;

export const getCategoryTotalSize = (state: State, categoryId: CategoryId) =>
	state.entities.browse[categoryId].totalSize;

export const getBrowseLimit = (state: State): number => state.entities.browse.limit;

export const getBrowseNextCursor = (state: State, categoryId: CategoryId): string =>
	state.entities.browse[categoryId] != null
		? state.entities.browse[categoryId].nextCursor ?? ''
		: '';

export const getBrowsePrevCursor = (state: State, categoryId: CategoryId): string =>
	state.entities.browse[categoryId] != null
		? state.entities.browse[categoryId].prevCursor ?? ''
		: '';

export const isCategoriesSupported = (state: State, categoryId: CategoryId): boolean =>
	state.entities.browse[categoryId] != null
		? state.entities.browse[categoryId].categoriesSupported ?? true
		: true;

export const isBrowseLoading = (state: State, categoryId: CategoryId) =>
	state.entities.browse[categoryId] === undefined;

export const getArticlesLoading = (state: State): boolean => !!state.entities.browse.loading;
